// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-4f43e928] {\n    cursor: pointer;\n}\ninput[type='checkbox'][data-v-4f43e928] {\n    cursor: pointer;\n}\ninput[type='checkbox'][data-v-4f43e928]:disabled {\n    cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
